
import lazyload from "@/directives/lazyload";
import Betty from "@/assets/images/landing/img/betty.webp";
import Mark from "@/assets/images/landing/img/mark.webp";
import Tina from "@/assets/images/landing/img/Tina.png";

import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "Tina J.",
          text:
            `I never feel like I am enough, have zero confidence, and am always doubting myself. When he asked me to move in I was so happy but scared too. The first couple of months were great. I felt wanted and appreciated. About four months in, we sort of slipped into a routine. I wasn’t surprised at first, I thought it happens to everybody. I started getting the feeling he was intentionally shutting me out. The passion was gone. I read an article about how guys who watch a lot of porn have unreal expectations about sex. Being with their real partner seems like a let down so they pull away… that stuck with me. I started paying attention and realized that every day he would go into the bedroom while I made dinner. When I asked him he told me he just needed to unwind after work. When he practically stopped touching me at all, I decided to see if he was subscribing to adult sites. I did an <strong>XXX Websites search</strong> and was shocked, there were things I definitely was not comfortable with. I am just glad I found out. It hurt a lot, but it has made me more aware.
`,
          imgMain: Tina,
          imgSecond: Betty,
          imgThird: Mark,
          logo: LogoAmerican,
        },
        {
          name: "Betty C.",
          text:
            `After a horrible experience with cheating exes, I have bigger trust issues than a regular person. The issue lies not in looks or personality but rather in the curiosity of most guys I’ve dated that they never stop looking for “someone better.” Ever since I discovered iFindCheaters’ extremely useful tool that lets me <strong>search on xxx sites</strong> before I even consider a second date has been empowering. Now, I use it to gauge the persona of my interest and decide whether I should be in a casual relationship or steer clear of them entirely! 10/10 would recommend this to everyone!`,
          imgMain: Betty,
          imgSecond: Mark,
          imgThird: Tina,
          logo: LogoAmerican,
        },
        {
          name: "Mark S.",
          text:
            `Many people perceive us guys to be obsessed with porn, irrespective of our relationship status. I used to be offended by that notion until I dealt with something similar. My last Tinder date seemed like a chill guy initially, genuinely interested in me, and hit it right off. After a couple of intensely hot weeks, it fizzled out as quickly as it started, but he would still text me asking me over to his place at odd hours. Weird out, I discussed this with my BFF, who suggested I <strong>search on xxx sites</strong> if I wanted answers. Lo and behold! There he was - excessively active! While I’m secure in my prowess, some guys really just can’t seem to be satisfied. To each his own, I guess, but I like to steer clear.`,
          imgMain: Mark,
          imgSecond: Tina,
          imgThird: Betty,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
